import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { addToCart } from "../../../redux/actions/cartActions";
import { addToWishlist } from "../../../redux/actions/wishlistActions";
import { addToCompare } from "../../../redux/actions/compareActions";
import { environment } from "../../../environment";
import ProductTeaser from "../productTeaser/ProductTeaser";
import ProductTeaserWrap from "./ProductTeaserWrap";

// Semantic banner size → Bootstrap column span + aspect ratio (mirrors the FTL bannerSizeStyle).
// Bootstrap rows can't span vertical grid tracks, so "tall"/"hero" express height via aspect-ratio
// instead of a row span.
const BANNER_LAYOUT = {
    regular: { col: "col-xl-4 col-sm-6", aspectRatio: "1 / 1" },
    wide: { col: "col-xl-8 col-sm-12", aspectRatio: "2 / 1" },
    tall: { col: "col-xl-4 col-sm-6", aspectRatio: "1 / 2" },
    hero: { col: "col-xl-8 col-sm-12", aspectRatio: "16 / 10" },
    full: { col: "col-12", aspectRatio: "4 / 1" },
};

// External commerce images are already absolute; a merchandising banner is a JCR DAM link
// (/dam/jcr:…) relative to the Magnolia host — prefix the base so it resolves from the :3000 origin.
const bannerImgSrc = (link) => (!link ? "" : /^(https?:)?\/\//i.test(link) ? link : environment.MAGNOLIA_BASE_URL + link);

const MerchandisingBanner = ({ link, size }) => {
    const layout = BANNER_LAYOUT[size] || BANNER_LAYOUT.regular;
    return (
        <div className={`${layout.col} mb-25`}>
            <div style={{ position: "relative", overflow: "hidden", borderRadius: 8, aspectRatio: layout.aspectRatio }}>
                <img src={bannerImgSrc(link)} alt="" loading="lazy" style={{ display: "block", width: "100%", height: "100%", objectFit: "cover" }} />
            </div>
        </div>
    );
};

const ProductGrid = ({ products, currency, addToCart, addToWishlist, addToCompare, cartItems, wishlistItems, compareItems }) => {
    return (
        <Fragment>
            {products.map((product) => {
                if (product.__banner) {
                    return <MerchandisingBanner key={product["@id"]} link={product.link} size={product.size} />;
                }
                return (
                    <div key={product["@id"]} className="col-xl-4 col-sm-6 mb-25">
                        <ProductTeaser
                            product={product}
                            currency={currency}
                            addToCart={addToCart}
                            addToWishlist={addToWishlist}
                            addToCompare={addToCompare}
                            cartItem={cartItems.filter((cartItem) => cartItem.id === product.id)[0]}
                            wishlistItem={wishlistItems.filter((wishlistItem) => wishlistItem.id === product.id)[0]}
                            compareItem={compareItems.filter((compareItem) => compareItem.id === product.id)[0]}
                        />
                        <ProductTeaserWrap
                            product={product}
                            currency={currency}
                            addToCart={addToCart}
                            addToWishlist={addToWishlist}
                            addToCompare={addToCompare}
                            cartItem={cartItems.filter((cartItem) => cartItem.id === product.id)[0]}
                            wishlistItem={wishlistItems.filter((wishlistItem) => wishlistItem.id === product.id)[0]}
                            compareItem={compareItems.filter((compareItem) => compareItem.id === product.id)[0]}
                        />
                    </div>
                );
            })}
        </Fragment>
    );
};

ProductGrid.propTypes = {
    addToCart: PropTypes.func,
    addToCompare: PropTypes.func,
    addToWishlist: PropTypes.func,
    cartItems: PropTypes.array,
    compareItems: PropTypes.array,
    currency: PropTypes.object,
    products: PropTypes.array,
    wishlistItems: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        currency: state.currencyData,
        cartItems: state.cartData,
        wishlistItems: state.wishlistData,
        compareItems: state.compareData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (item, addToast, quantityCount, selectedProductColor, selectedProductSize) => {
            dispatch(addToCart(item, addToast, quantityCount, selectedProductColor, selectedProductSize));
        },
        addToWishlist: (item, addToast) => {
            dispatch(addToWishlist(item, addToast));
        },
        addToCompare: (item, addToast) => {
            dispatch(addToCompare(item, addToast));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGrid);
